import { useEffect, useState } from "react";

import {
  Box,
  Container,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";

import ThreadCard from "@/components/ThreadCard";
import NewThreadContainer from "./NewThreadContainer";

import BottomTabs from "@/components/BottomTabs";
import MainAppBar from "@/components/MainAppBar";
import { useThreads } from "@/services/hooks";
import SideTabs from "@/components/SideTabs";
import { useParams } from "react-router-dom";
import { SubscribedProvider } from "@/providers/Subscribed";

export default function Threads() {
  const params = new URLSearchParams(location.search);
  const contentKey = params.get("contentKey");

  const { artistKey } = useParams();

  const { data: artistContent, isLoading } = useThreads(artistKey);
  const [open, setOpen] = useState(false);
  const [sortMethod, setSortMethod] = useState("recent"); // State for sorting method

  useEffect(() => {
    if (!isLoading && contentKey) {
      const element = document.getElementById(contentKey);
      console.log("scrolling to", contentKey);
      if (element) {
        element.scrollIntoView();
        setTimeout(() => {
          window.scrollBy(0, -50); // Scrolls up by 50px
        }, 1);
      }
    }
  }, [isLoading, contentKey]);

  // Sort the artistContent based on the selected sort method
  const sortedContent = artistContent?.sort((a, b) => {
    if (sortMethod === "recent") {
      return b.updated - a.updated;
    } else if (sortMethod === "comment_count") {
      return b.comment_count - a.comment_count;
    }
    return 0;
  });

  return (
    <SubscribedProvider artistKey={artistKey}>
      <Container maxWidth="sm">
        <MainAppBar />

        <Box id="main-feed">
          <Box sx={{ px: 0 }}>
            <NewThreadContainer
              open={open}
              setOpen={setOpen}
              // fetchArtistContent={fetchArtistContent}
            />

            {isLoading && <Loading />}

            <FormControl
              fullWidth
              variant="outlined"
              sx={{ my: 2, opacity: 0.9 }}
            >
              <InputLabel>Sort By</InputLabel>
              <Select
                value={sortMethod}
                onChange={(e) => setSortMethod(e.target.value)}
                label="Sort By"
                sx={{ borderRadius: "30px" }}
              >
                <MenuItem value="recent">Most Recent</MenuItem>
                <MenuItem value="comment_count">Most Active</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box style={{ marginBottom: "100px" }}>
            {sortedContent?.map((content, index) => (
              <Box key={index}>
                <ThreadCard key={index} content={content} />
                <Divider />
              </Box>
            ))}
          </Box>
        </Box>

        <BottomTabs />
        <SideTabs />
      </Container>
    </SubscribedProvider>
  );
}

function Loading() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 2,
        mt: 2,
        // p: 2,
      }}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height={50}
        style={{ borderRadius: "25px" }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        style={{ borderRadius: "25px" }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        style={{ borderRadius: "25px" }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        style={{ borderRadius: "25px" }}
      />
    </Box>
  );
}
